// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ExportDelivery\ApiExportDelivery.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { ExportPayload, ExportPayloadData, ExportPayloadOptions } from 'data/models/ExportPayload';
import { ExportDeliveryStatus } from 'server/enums/ExportDeliveryStatus';

// ExportDeliveryData is the class that ExportDelivery serializes to/from
export interface ExportDeliveryData {
    Id : number;
	
    ExportPayload : ExportPayloadData | null;
    ExportPayloadId : number;
	
    ErrorMessage : string | null;
    Guid : /* GUID */ string;
    InitiatedDate : /* ISO8601 */ string;
    Status : ExportDeliveryStatus;
}

// ExportDeliveryOptions is the class which may be passed to the ExportDelivery constructor to define optional initial data values
export interface ExportDeliveryOptions {
    Id : number;
	
    ExportPayload? : ExportPayloadOptions | null;
    ExportPayloadId? : number;
	
    ErrorMessage? : string | null;
    Guid? : /* GUID */ string;
    InitiatedDate? : /* ISO8601 */ string;
    Status? : ExportDeliveryStatus;
}

export class ExportDelivery {
    public Id : DataSignal<number>;
	
    public ExportPayload : DataSignal<ExportPayload | null>;
    public ExportPayloadId : DataSignal<number>;
	
    public ErrorMessage : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public InitiatedDate : DataSignal<TZDate>;
    public Status : DataSignal<ExportDeliveryStatus>;

    constructor();
    constructor(data : ExportDeliveryOptions);
    constructor(data: ExportDeliveryOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ExportPayload = S.value<ExportPayload | null>(null);
        this.ExportPayloadId = jsonableObservable(S.value<number>(data && data.ExportPayloadId !== undefined ? data.ExportPayloadId : 0));
	    
        this.ErrorMessage = jsonableObservable(S.value<string | null>(data && data.ErrorMessage !== undefined ? data.ErrorMessage : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.InitiatedDate = jsonableObservable(S.value<TZDate>(data && data.InitiatedDate !== undefined ? new TZDate(data.InitiatedDate) : new TZDate(0), TZDate.eq));
        this.Status = jsonableObservable(S.value<ExportDeliveryStatus>(data && data.Status !== undefined ? data.Status : 0));
    }

    static key(obj : ExportDelivery) {
        return obj.Id();
    }
    
    static dataKey(obj : ExportDeliveryOptions) {
        return obj.Id;
    }

    static update(obj : ExportDelivery, data : ExportDeliveryOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ExportPayloadId !== undefined) obj.ExportPayloadId(data.ExportPayloadId);
	        
            if (data.ErrorMessage !== undefined) obj.ErrorMessage(data.ErrorMessage);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.InitiatedDate !== undefined) obj.InitiatedDate(new TZDate(data.InitiatedDate));
            if (data.Status !== undefined) obj.Status(data.Status);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ExportDelivery.ts